export default __webpack_public_path__ + "static/media/virgo.760dda5f.png";